// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control .checkbox input + span[data-v-b4a1cfc4] {\n  font-weight: normal;\n}", ""]);
// Exports
module.exports = exports;
